// These are essentially the same as correctBreakpoints2023
// the values are just evaluated a bit differently
export enum BREAKPOINTS {
  'mobile' = 1,
  'sx' = 600,
  'md' = 900,
  'lg' = 1200,
}

export const correctBreakpoints2023 = {
  // considered mobile
  // XS: 0-599
  XS: 599,
  // considered tablets
  // S: 600-899
  SM: 899,
  // M: 900-1199
  MD: 1199,
  // L: 1200-1535
  LG: 1535,
} as const;

export const correctImageBreakpoints2023 = {
  // XXS: 0-199
  XXXS: 199,
  // XS: 200-399
  XXS: 399,
  // XS: 400-599
  XS: 599,
  // S: 600-899
  SM: 899,
  // M: 900-1199
  MD: 1199,
  // L: 1200-1535
  LG: 1535,
  // L: 1536-1920
  XL: 1920,
  // L: 1921-2048
  XXL: 2048,
  // L: 2049-3840
  XXXL: 3840,
};

export const largestPageWidth = correctBreakpoints2023.LG;

export type ImageBreakpointKeys = keyof typeof correctImageBreakpoints2023;

export const imageBreakpointKeys: ImageBreakpointKeys[] = Object.entries(
  correctImageBreakpoints2023
)
  .sort(([, valueA], [, valueB]) => valueA - valueB)
  .map(([key]) => key as ImageBreakpointKeys);
